import Clipboard from '@react-native-clipboard/clipboard';

export const copyToClipboard = text => {
  Clipboard.setString(text);
};
